import {computed, PropType} from "vue";
import {PageDataHolderFetchedWidget} from "../../lib/interfaces/model/PageDataHolderFetchedWidget";
import {Widget} from "../../lib/interfaces/model/Widget";

export function useWidget(widget: PageDataHolderFetchedWidget) {

    const content = computed<String>(() => widget.content as String);

    return {content: content.value as String, widgetData: widget.widget as Widget};
}
